import { createSelector } from 'reselect';

import {
  selectEntitiesMissionsEntityAchievementIds,
  selectEntitiesMissionsEntityOptInEnabled,
} from '../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { type Selector } from '../../../types/selectors';
import { UserAchievementStatuses } from '../types/state/userMissions';
import { type UserMissionAchievementState } from '../types/state/userMissions';

import { selectUserMission, selectUserMissionHasUserRegistered } from './userMissions';
import { getAchievementIdFromProps } from './utils';

export const selectUserMissionAchievements: Selector<Array<UserMissionAchievementState | undefined>> = createSelector(
  [selectEntitiesMissionsEntityAchievementIds, selectUserMission],
  (achievementIds, userMission) =>
    achievementIds.map((achievementId) => userMission?.achievements?.[achievementId]).filter((k) => k),
);

export const selectUserMissionAchievement: Selector<UserMissionAchievementState | undefined> = createSelector(
  [selectUserMission, getAchievementIdFromProps],
  (userMission, achievementId) => (achievementId ? userMission?.achievements?.[achievementId] : undefined),
);

export const selectUserMissionAchievementIsWon: Selector<boolean> = createSelector(
  [selectUserMissionAchievement, selectEntitiesMissionsEntityOptInEnabled, selectUserMissionHasUserRegistered],
  (userMissionAchievement, optInRequired, hasUserRegistered) => {
    if (optInRequired && !hasUserRegistered) {
      return false;
    }

    return userMissionAchievement?.status === UserAchievementStatuses.WON;
  },
);
